import { createSelector } from '@reduxjs/toolkit';

import { DisclaimerDisplayTypeEnum } from '@/interfaces/settings.interfaces';
import { II18Service } from '@/services/I18Service';
import injectContainer from '@/services/InjectContainer';
import ServiceTypes from '@/services/ServiceTypes';

import configSelector from './config';

const benefitsSelector = createSelector(configSelector, config => {
  const { benefits } = config;
  const { i18n } = injectContainer.get<II18Service>(ServiceTypes.I18N);
  return {
    ...benefits,
    enable: benefits?.enable ?? false,
    showAmount: benefits?.showAmount ?? true,
    showOnlyBlock: benefits?.showOnlyBlock ?? false,
    disclaimerDisplayType:
      benefits?.disclaimerDisplayType ?? DisclaimerDisplayTypeEnum.Paragraph,
    title: benefits?.title ?? `${i18n.t('benefitsBlock.title')}`,
    maxBenefit: benefits?.maxBenefit ?? `${i18n.t('benefitsBlock.maxBenefit')}`,
    priceWithBenefit:
      benefits?.priceWithBenefit ?? `${i18n.t('benefitsBlock.priceWithBenefit')}`,
    retailPrice: benefits?.retailPrice ?? `${i18n.t('benefitsBlock.retailPrice')}`,
    totalBenefit: benefits?.totalBenefit ?? `${i18n.t('benefitsBlock.totalBenefit')}`,
    tooltipTitle: benefits?.tooltipTitle ?? `${i18n.t('benefitsBlock.tooltipTitle')}`,
    tooltipBenefitColumn:
      benefits?.tooltipBenefitColumn ?? `${i18n.t('benefitsBlock.tooltipBenefitColumn')}`,
    tooltipDiscountColumn:
      benefits?.tooltipDiscountColumn ??
      `${i18n.t('benefitsBlock.tooltipDiscountColumn')}`,
    tooltipPriceColumn:
      benefits?.tooltipPriceColumn ?? `${i18n.t('benefitsBlock.tooltipPriceColumn')}`,
    markersTooltipTitle:
      benefits?.markersTooltipTitle ?? `${i18n.t('benefitsBlock.markersTooltipTitle')}`,
  };
});

export default benefitsSelector;
